<template>
  <div
    :class="{
      'catalog-slider-item-fi': true,
      'catalog-slider-item-fi--is-thumbnail': isThumbnail,
    }"
    @click="onZoom"
  >
    <video-player-fi
      v-if="item.videoId"
      ref="video"
      :fields="getYoutubeVideoFields(item.videoId, item.Url)"
      :show-hide-delay="1000"
      :reset-video="slideChanged"
      :aspect-ratio="16 / 9"
      :overlay-breakpoints="breakpoints"
      :unlimited="unlimited"
      :unlimited-height="unlimitedHeight"
      :small-play-button="isThumbnail"
      :is-thumbnail="isThumbnail"
      preview-params="func=crop&org_if_sml=0"
      do-not-replace-url
      no-youku-player
    />
    <div
      v-else
      class="catalog-slider-item-fi__image-container"
      data-test="catalog-slider-item-image-container"
    >
      <div
        v-if="zoomable"
        class="catalog-slider-item-fi__zoom fi-hidden md:fi-block"
      >
        <icon-fi icon="zoom-in" />
        {{ $dict.get('product-Catalog.Zoom') }}
      </div>
      <div
        :class="{
          'catalog-slider-item-fi__image-wrapper': true,
          'catalog-slider-item-fi__image-wrapper--product-picture':
            !isThumbnail && isProductPicture,
        }"
      >
        <ssr-cloud-image-fi
          class="thumbnail-slider-item-fi__image"
          :src="item.Url"
          :params="cloudImageParams"
          :trim="item.Type === 'Product Category Picture' || item.Type === 'Product Picture'"
          :breakpoints="breakpoints"
          :unlimited="unlimited"
          :unlimited-height="unlimitedHeight"
          :alt="
            isProductPicture && itemName ? `${item.altText}: &quot;${itemName}&quot;` : item.altText
          "
          :eager="eager"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { IconFi, SsrCloudImageFi } from 'atoms';

import VideoPlayerFi from '@/components/video-player-fi/VideoPlayerFi.vue';

export default {
  name: 'CatalogSliderItemFi',
  components: {
    VideoPlayerFi,
    IconFi,
    SsrCloudImageFi,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    isThumbnail: {
      type: Boolean,
      default: false,
    },
    slideChanged: {
      type: Boolean,
      default: false,
    },
    itemName: {
      type: String,
      default: null,
    },
    zoomable: Boolean,
    isZoom: Boolean,
    eager: Boolean,
  },
  emits: ['zoom'],
  computed: {
    isProductPicture() {
      const regularItemTypes =
        this.item.Type === 'Product Category Picture' ||
        this.item.Type === 'Product Picture' ||
        this.item.Type === 'Packaging';
      return this.isFite
        ? regularItemTypes || this.item.Type === 'Application Picture'
        : regularItemTypes;
    },
    cloudImageParams() {
      return this.isProductPicture
        ? 'func=fit&bg_colour=fff&org_if_sml=0'
        : 'func=crop&org_if_sml=0';
    },
    paddingMd() {
      return this.isProductPicture ? 2 * 60 : 0;
    },
    paddingLg() {
      return this.isProductPicture ? 2 * 80 : 0;
    },
    breakpoints() {
      if (this.isThumbnail) {
        return [
          {
            mediaWidth: 480,
            imageWidth: 444 / 3,
            imageHeight: (444 / 3 / 16) * 9,
          },
          {
            mediaWidth: 767,
            imageWidth: 731 / 3,
            imageHeight: (731 / 3 / 16) * 9,
          },
          {
            mediaWidth: 768,
            imageWidth: 708 / 3,
            imageHeight: (708 / 3 / 16) * 9,
          },
          {
            mediaWidth: 1023,
            imageWidth: 963 / 3,
            imageHeight: (963 / 3 / 16) * 9,
          },
          {
            mediaWidth: 1440,
            imageWidth: 534 / 3,
            imageHeight: (534 / 3 / 16) * 9,
          },
        ];
      }
      if (this.isZoom) {
        return [
          {
            mediaWidth: 1440,
            imageWidth: 1380 - this.paddingLg,
            imageHeight: (1380 / 16) * 9,
          },
        ];
      }
      return [
        {
          mediaWidth: 480,
          imageWidth: 444,
          imageHeight: (444 / 16) * 9,
        },
        {
          mediaWidth: 767,
          imageWidth: 731,
          imageHeight: (731 / 16) * 9,
        },
        {
          mediaWidth: 768,
          imageWidth: 708,
          imageHeight: (708 / 16) * 9,
        },
        {
          mediaWidth: 1023,
          imageWidth: 963 - this.paddingMd,
          imageHeight: (963 / 16) * 9,
        },
        {
          mediaWidth: 1440,
          imageWidth: 534 - this.paddingLg,
          imageHeight: (534 / 16) * 9,
        },
      ];
    },
    unlimited() {
      if (this.isThumbnail) {
        return 798 / 3;
      }
      if (this.isZoom) {
        return 1860 - this.paddingLg;
      }
      return 798 - this.paddingLg;
    },
    unlimitedHeight() {
      if (this.isThumbnail) {
        return ((798 / 3) * 9) / 16;
      }
      if (this.isZoom) {
        return (1860 * 9) / 16;
      }
      return (798 * 9) / 16;
    },
  },
  methods: {
    onSwipe() {
      if (this.$refs.video?.isPlaying) {
        this.$refs.video.videoEnded();
      }
    },
    onZoom() {
      if (this.zoomable) {
        this.$emit('zoom');
      }
    },
    getYoutubeVideoFields(videoId, imageUrl) {
      return {
        videoYoutubeLink: {
          value: {
            href: `https://www.youtube.com/watch?v=${videoId}`,
            url: `https://www.youtube.com/watch?v=${videoId}`,
            text: 'Youtube Video',
            altTitle: 'Youtube Video',
          },
        },
        image: {
          value: {
            src: imageUrl,
            alt: 'Youtube Video',
          },
        },
      };
    },
  },
};
</script>

<style src="./catalog-slider-item-fi" />
